import { StyleSheet } from 'aphrodite';
import { aceGray, charmGray, white } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	checkboxPlaceholder: {
		alignItems: 'center',
		display: 'flex',
		paddingRight: 10,
		width: 15,
	},
	headerPlaceholder: {
		minWidth: 100,
		flex: '0.25',
	},
	header: {
		borderBottom: `1px solid ${aceGray}`,
		color: charmGray,
		display: 'flex',
		paddingBottom: 12,
		paddingTop: 12,
		paddingLeft: 16,
		paddingRight: 16,
		width: '100%',
		boxSizing: 'border-box',
		background: white,
	},
	headerTitle: {
		fontSize: 11,
		fontStyle: 'normal',
		fontWeight: 'normal',
		letterSpacing: '1.1px',
		lineHeight: '15px',
		minWidth: 100,
		flex: 1,
		textTransform: 'uppercase',
	},
	headerTitleSubject: {
		fontSize: 11,
		fontStyle: 'normal',
		fontWeight: 'normal',
		letterSpacing: '1.1px',
		lineHeight: '15px',
		minWidth: 120,
		maxWidth: 400,
		flex: 1,
		textTransform: 'uppercase',
	},
	headerTitleTags: {
		fontSize: 11,
		fontStyle: 'normal',
		fontWeight: 'normal',
		letterSpacing: '1.1px',
		lineHeight: '15px',
		minWidth: 100,
		maxWidth: 400,
		flex: 1,
		textTransform: 'uppercase',
	},
});
